import { render } from "./CustomerRegister.vue?vue&type=template&id=64edea37&scoped=true"
import script from "./CustomerRegister.vue?vue&type=script&lang=js"
export * from "./CustomerRegister.vue?vue&type=script&lang=js"

import "./CustomerRegister.vue?vue&type=style&index=0&id=64edea37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64edea37"]])

export default __exports__